/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BankAccountEventTimelinePayload } from './';
import {
    BankAccountEventTimelinePayloadFromJSON,
    BankAccountEventTimelinePayloadFromJSONTyped,
    BankAccountEventTimelinePayloadToJSON,
} from './';
import type { CompanyTypeEventTimelinePayload } from './';
import {
    CompanyTypeEventTimelinePayloadFromJSON,
    CompanyTypeEventTimelinePayloadFromJSONTyped,
    CompanyTypeEventTimelinePayloadToJSON,
} from './';
import type { DocumentUploadRequestedEventTimelinePayload } from './';
import {
    DocumentUploadRequestedEventTimelinePayloadFromJSON,
    DocumentUploadRequestedEventTimelinePayloadFromJSONTyped,
    DocumentUploadRequestedEventTimelinePayloadToJSON,
} from './';
import type { FraudReportEventTimelinePayload } from './';
import {
    FraudReportEventTimelinePayloadFromJSON,
    FraudReportEventTimelinePayloadFromJSONTyped,
    FraudReportEventTimelinePayloadToJSON,
} from './';
import type { FreelancerComplianceBlockingEventTimelinePayload } from './';
import {
    FreelancerComplianceBlockingEventTimelinePayloadFromJSON,
    FreelancerComplianceBlockingEventTimelinePayloadFromJSONTyped,
    FreelancerComplianceBlockingEventTimelinePayloadToJSON,
} from './';
import type { IdentityVerificationStatusEventTimelinePayload } from './';
import {
    IdentityVerificationStatusEventTimelinePayloadFromJSON,
    IdentityVerificationStatusEventTimelinePayloadFromJSONTyped,
    IdentityVerificationStatusEventTimelinePayloadToJSON,
} from './';
import type { KycDocumentEventTimelinePayload } from './';
import {
    KycDocumentEventTimelinePayloadFromJSON,
    KycDocumentEventTimelinePayloadFromJSONTyped,
    KycDocumentEventTimelinePayloadToJSON,
} from './';
import type { KycDocumentStoredEventTimelinePayload } from './';
import {
    KycDocumentStoredEventTimelinePayloadFromJSON,
    KycDocumentStoredEventTimelinePayloadFromJSONTyped,
    KycDocumentStoredEventTimelinePayloadToJSON,
} from './';
import type { KycStatusTimelinePayload } from './';
import {
    KycStatusTimelinePayloadFromJSON,
    KycStatusTimelinePayloadFromJSONTyped,
    KycStatusTimelinePayloadToJSON,
} from './';
import type { PartnerKycStatusTimelinePayload } from './';
import {
    PartnerKycStatusTimelinePayloadFromJSON,
    PartnerKycStatusTimelinePayloadFromJSONTyped,
    PartnerKycStatusTimelinePayloadToJSON,
} from './';
import type { UboDeclarationEventTimelinePayload } from './';
import {
    UboDeclarationEventTimelinePayloadFromJSON,
    UboDeclarationEventTimelinePayloadFromJSONTyped,
    UboDeclarationEventTimelinePayloadToJSON,
} from './';
import type { UmbrellaEventTimelinePayload } from './';
import {
    UmbrellaEventTimelinePayloadFromJSON,
    UmbrellaEventTimelinePayloadFromJSONTyped,
    UmbrellaEventTimelinePayloadToJSON,
} from './';
import type { UmbrellaInvitedEventTimelinePayload } from './';
import {
    UmbrellaInvitedEventTimelinePayloadFromJSON,
    UmbrellaInvitedEventTimelinePayloadFromJSONTyped,
    UmbrellaInvitedEventTimelinePayloadToJSON,
} from './';
import type { UserEventTimelinePayload } from './';
import {
    UserEventTimelinePayloadFromJSON,
    UserEventTimelinePayloadFromJSONTyped,
    UserEventTimelinePayloadToJSON,
} from './';
import type { UserRefusedEventTimelinePayload } from './';
import {
    UserRefusedEventTimelinePayloadFromJSON,
    UserRefusedEventTimelinePayloadFromJSONTyped,
    UserRefusedEventTimelinePayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface ComplianceTimelineEventPayload
 */
export interface ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof ComplianceTimelineEventPayload
     */
    type: string;
}

/**
 * Check if a given object implements the ComplianceTimelineEventPayload interface.
 */
export function instanceOfComplianceTimelineEventPayload(value: object): value is ComplianceTimelineEventPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ComplianceTimelineEventPayloadFromJSON(json: any): ComplianceTimelineEventPayload {
    return ComplianceTimelineEventPayloadFromJSONTyped(json, false);
}

export function ComplianceTimelineEventPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceTimelineEventPayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'BANK_ACCOUNT_EVENT') {
            return BankAccountEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'COMPANY_TYPE_EVENT') {
            return CompanyTypeEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'DOCUMENT_EVENT') {
            return KycDocumentEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'DOCUMENT_STORED_EVENT') {
            return KycDocumentStoredEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'DOCUMENT_UPLOAD_REQUESTED') {
            return DocumentUploadRequestedEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'FRAUD_REPORT') {
            return FraudReportEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'FREELANCER_COMPLIANCE_BLOCKING_EVENT') {
            return FreelancerComplianceBlockingEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'IDENTITY_VERIFICATION_STATUS_EVENT') {
            return IdentityVerificationStatusEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'PARTNER_STATUS_EVENT') {
            return PartnerKycStatusTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'STATUS_EVENT') {
            return KycStatusTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'UBO_DECLARATION') {
            return UboDeclarationEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'UMBRELLA_EVENT') {
            return UmbrellaEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'UMBRELLA_INVITED_EVENT') {
            return UmbrellaInvitedEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'USER_EVENT') {
            return UserEventTimelinePayloadFromJSONTyped(json, true);
        }
        if (json['type'] === 'USER_REFUSED_EVENT') {
            return UserRefusedEventTimelinePayloadFromJSONTyped(json, true);
        }
    }
    return {
        
        'type': json['type'],
    };
}

export function ComplianceTimelineEventPayloadToJSON(value?: ComplianceTimelineEventPayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'BANK_ACCOUNT_EVENT') {
            return BankAccountEventTimelinePayloadToJSON(value as BankAccountEventTimelinePayload);
        }
        if (value.type === 'COMPANY_TYPE_EVENT') {
            return CompanyTypeEventTimelinePayloadToJSON(value as CompanyTypeEventTimelinePayload);
        }
        if (value.type === 'DOCUMENT_EVENT') {
            return KycDocumentEventTimelinePayloadToJSON(value as KycDocumentEventTimelinePayload);
        }
        if (value.type === 'DOCUMENT_STORED_EVENT') {
            return KycDocumentStoredEventTimelinePayloadToJSON(value as KycDocumentStoredEventTimelinePayload);
        }
        if (value.type === 'DOCUMENT_UPLOAD_REQUESTED') {
            return DocumentUploadRequestedEventTimelinePayloadToJSON(value as DocumentUploadRequestedEventTimelinePayload);
        }
        if (value.type === 'FRAUD_REPORT') {
            return FraudReportEventTimelinePayloadToJSON(value as FraudReportEventTimelinePayload);
        }
        if (value.type === 'FREELANCER_COMPLIANCE_BLOCKING_EVENT') {
            return FreelancerComplianceBlockingEventTimelinePayloadToJSON(value as FreelancerComplianceBlockingEventTimelinePayload);
        }
        if (value.type === 'IDENTITY_VERIFICATION_STATUS_EVENT') {
            return IdentityVerificationStatusEventTimelinePayloadToJSON(value as IdentityVerificationStatusEventTimelinePayload);
        }
        if (value.type === 'PARTNER_STATUS_EVENT') {
            return PartnerKycStatusTimelinePayloadToJSON(value as PartnerKycStatusTimelinePayload);
        }
        if (value.type === 'STATUS_EVENT') {
            return KycStatusTimelinePayloadToJSON(value as KycStatusTimelinePayload);
        }
        if (value.type === 'UBO_DECLARATION') {
            return UboDeclarationEventTimelinePayloadToJSON(value as UboDeclarationEventTimelinePayload);
        }
        if (value.type === 'UMBRELLA_EVENT') {
            return UmbrellaEventTimelinePayloadToJSON(value as UmbrellaEventTimelinePayload);
        }
        if (value.type === 'UMBRELLA_INVITED_EVENT') {
            return UmbrellaInvitedEventTimelinePayloadToJSON(value as UmbrellaInvitedEventTimelinePayload);
        }
        if (value.type === 'USER_EVENT') {
            return UserEventTimelinePayloadToJSON(value as UserEventTimelinePayload);
        }
        if (value.type === 'USER_REFUSED_EVENT') {
            return UserRefusedEventTimelinePayloadToJSON(value as UserRefusedEventTimelinePayload);
        }
    }
    return {
        
        'type': value['type'],
    };
}

